import { C4_BOT } from './c4/cpu'
import type { GameId } from './duel/protocol'
import type { PlayerPublic } from './protocol'
import { CPU_PLAYER } from './xox/cpu'

/** The house bot of each duel, for copy that only knows the game id (banners, history). */
export const BOTS: Record<GameId, PlayerPublic> = { xox: CPU_PLAYER, c4: C4_BOT }
